import {
  SidebarContent,
  SidebarContentTrigger,
  SidebarGroup,
  SidebarGroupContent,
  SidebarSeparator,
} from '@/components/ui/sidebar'
import { useAuth } from '@/services/providers/auth-provider'
import Link from 'next/link'

export function AppSidebarContent() {
  const auth = useAuth()

  return (
    <>
      <SidebarSeparator className="mx-5 h-[0.5px] bg-black" />
      <SidebarContent className="mb-8 mt-4 w-full overflow-hidden text-xl font-bold">
        <SidebarGroup className="mx-7 gap-6">
          <SidebarGroupContent className="text-base text-black">
            <Link href="/" className="cursor-pointer">
              งานแข่ง
            </Link>
          </SidebarGroupContent>
          <SidebarGroupContent className="text-base text-black">
            <Link href="/about" className="cursor-pointer">
              เกี่ยวกับ
            </Link>
          </SidebarGroupContent>
          <SidebarGroupContent className="text-base text-black">
            <Link href="/contact" className="cursor-pointer">
              ติดต่อ
            </Link>
          </SidebarGroupContent>
        </SidebarGroup>
        {auth.isAuthenticated() && (
          <SidebarSeparator className="mx-8 h-[1px] bg-black/20" />
        )}

        <SidebarGroup className="mx-7 gap-5">
          {auth.isAuthenticated() && (
            <>
              <SidebarContentTrigger contentType="profile" variant="nohover">
                <h1 className="z-50 cursor-pointer text-base font-bold text-zinc-950">
                  แก้ไขข้อมูลผู้ใช้งาน
                </h1>
              </SidebarContentTrigger>
            </>
          )}
        </SidebarGroup>

        <SidebarSeparator className="mx-5 h-[1px] bg-black/50" />

        <SidebarGroup>
          <SidebarGroupContent className="mt-2 flex justify-center">
            {!auth.isAuthenticated() ? (
              <Link
                href={
                  '/signin?' +
                  new URLSearchParams({
                    navigateTo: window.location.pathname,
                  }).toString()
                }
                className="z-50 flex h-full w-fit cursor-pointer items-center gap-2 rounded-full bg-zinc-900 px-4 py-2 font-line text-base text-white transition-colors hover:bg-zinc-800"
              >
                เข้าสู่ระบบ
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-5 w-5"
                >
                  <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                  <polyline points="10 17 15 12 10 7" />
                  <line x1="15" x2="3" y1="12" y2="12" />
                </svg>
              </Link>
            ) : (
              <button
                onClick={() => auth.signOut()}
                className="z-50 flex h-full w-fit cursor-pointer items-center gap-2 rounded-full bg-red-500 px-4 py-2 font-line text-base text-white transition-colors hover:bg-red-600"
              >
                ออกจากระบบ
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="h-5 w-5"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" x2="9" y1="12" y2="12" />
                </svg>
              </button>
            )}
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
